export const SCHEDULE_STATUS_DAY_OPEN = 1;
export const SCHEDULE_STATUS_DAY_CLOSE = 2;
export const SCHEDULE_STATUS_DAY_WEEKEND = 3;
export const SCHEDULE_STATUS_DAY_CLOSE_ALWAYS = 4;

export const SCHEDULE_STATUS_OPEN = 1;
export const SCHEDULE_STATUS_ORDER = 2;
export const SCHEDULE_STATUS_CLOSE = 3;

export const SCHEDULE_TYPE_OFFICE = 1;
export const SCHEDULE_TYPE_ONLINE = 2;

export const isClosedDayStatus = (status?: number): boolean =>
  status === SCHEDULE_STATUS_DAY_CLOSE ||
  status === SCHEDULE_STATUS_DAY_CLOSE_ALWAYS ||
  status === SCHEDULE_STATUS_DAY_WEEKEND;

export const isClosedSlotStatus = (status?: number): boolean =>
  status === SCHEDULE_STATUS_CLOSE;
